import "./signup.css";
import Logo1 from "../../assets/icons/logo1";
import Logo from "../../assets/icons/logo";
import Input from "antd/lib/input";
import Button from "antd/lib/button";
import Select from "antd/lib/select";
import TextArea from "antd/lib/input/TextArea";
import { useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import { IoIosArrowBack } from "react-icons/io";
import DoneIcon from "../../assets/icons/doneIcon";
import useAuth from "../../hooks/use_auth";
import { useEffect } from "react";
import { GendersEnum } from "../../utils/enums";
import Countdown, { zeroPad } from "react-countdown";
import TermsAcceptance from "../../components/terms_acceptance";

const Signup = () => {
  const navigate = useNavigate();
  const {
    // entity methods
    resendVerificationCode,
    getCountries,
    getCategories,
    // controller methods
    signupController,
    verifySignupController,
    // entity states
    countries,
    categories,
    // controller states
    step,
    setStep,
    showReset,
    setShowReset,
    now,
    setNow,
    // loading states
    loadings,
    getCountriesLoading,
  } = useAuth();

  const renderer = ({ minutes, seconds }) => {
    return (
      <div className={"time_resend_code"}>
        <span
          className="font_medium"
          style={
            showReset ? { color: "var(--second)" } : { color: "var(--blue)" }
          }
        >
          {zeroPad(minutes)} : {zeroPad(seconds)}
        </span>
      </div>
    );
  };

  useEffect(() => {
    getCountries();
    getCategories();

    if (localStorage.getItem("token")) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <div className="signup">
      {step == 1 ? (
        <div className="signup_container">
          <div className="logo">
            <Logo1 />
          </div>
          <div className="logo_mobile">
            <Logo />
          </div>
          {/* tabs_container */}
          <div className="tabs_container">
            <div
              onClick={() => {
                navigate("/login");
              }}
            >
              Login
            </div>
            <div className={"avtive_tab"}>Sign Up</div>
          </div>
          {/* signup_form */}
          <form
            onSubmit={signupController.handleSubmit}
            className="signup_form"
            noValidate
          >
            <div className="name_expertise">
              {/* fullname */}
              <div className="full_name">
                <label htmlFor="fullname">Full name</label>
                <Input
                  value={signupController.values.fullname}
                  onChange={signupController.handleChange}
                  name="fullname"
                  type="fullname"
                  autoFocus={true}
                  disabled={loadings.signup}
                  placeholder="For example John Johnson"
                  status={
                    signupController.touched.fullname &&
                    signupController.errors.fullname
                      ? "error"
                      : ""
                  }
                />
              </div>
              {/* countryId */}
              <div className="country">
                <label>Country</label>
                <Select
                  value={signupController.values.countryId}
                  onChange={(value) => {
                    signupController.setFieldValue("countryId", value);
                  }}
                  disabled={loadings.signup}
                  status={
                    signupController.touched.countryId &&
                    signupController.errors.countryId
                      ? "error"
                      : ""
                  }
                  showSearch
                  filterOption={(input, option) =>
                    option?.label
                      ?.toString()
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  loading={getCountriesLoading}
                  placeholder="Choose your country"
                  options={countries?.map((country) => {
                    return {
                      label: `${country.flag} ${country.name}`,
                      value: country.id,
                    };
                  })}
                />
              </div>
            </div>
            {/* expertise */}
            <div className="expertise">
              <label>Expertises</label>
              <Select
                value={signupController.values.categoryIds}
                onChange={(value) => {
                  signupController.setFieldValue("categoryIds", value);
                }}
                showSearch={true}
                filterOption={(input, option) =>
                  option?.label
                    ?.toString()
                    ?.toLowerCase()
                    .includes(input.toLowerCase())
                }
                mode="multiple"
                disabled={loadings.getCategories || loadings.signup}
                loading={loadings.getCategories}
                options={categories}
                placeholder="Choose your expertises"
                status={
                  signupController.touched.categoryIds &&
                  signupController.errors.categoryIds
                    ? "error"
                    : ""
                }
              />
            </div>
            {/* bio */}
            <div className="about_me">
              <label htmlFor="bio">About me</label>
              <TextArea
                value={signupController.values.bio}
                onChange={signupController.handleChange}
                status={
                  signupController.touched.bio && signupController.errors.bio
                    ? "error"
                    : ""
                }
                disabled={loadings.signup}
                name="bio"
                id="bio"
                placeholder="Tell about yourself"
                rows={2}
              />
            </div>
            <div className="phone_email">
              {/* mobile */}
              <div className="phone">
                <label htmlFor="mobile">Mobile number</label>
                <Input
                  value={signupController.values.mobile}
                  onChange={signupController.handleChange}
                  name="mobile"
                  id="mobile"
                  type="tel"
                  disabled={loadings.signup}
                  placeholder="For example 09129272682"
                  status={
                    signupController.touched.mobile &&
                    signupController.errors.mobile
                      ? "error"
                      : ""
                  }
                />
              </div>
              {/* email */}
              <div className="email">
                <label htmlFor="email">Email</label>
                <Input
                  type="email"
                  name="email"
                  id="mobile"
                  disabled={loadings.signup}
                  value={signupController.values.email}
                  onChange={signupController.handleChange}
                  placeholder="Par...@gmail.com"
                  status={
                    signupController.touched.email &&
                    signupController.errors.email
                      ? "error"
                      : ""
                  }
                />
              </div>
            </div>
            <div className="country_address">
              {/* gender */}
              <div className="country">
                <label>Gender</label>
                <Select
                  value={signupController.values.gender}
                  onChange={(value) => {
                    signupController.setFieldValue("gender", value);
                  }}
                  disabled={loadings.signup}
                  status={
                    signupController.touched.gender &&
                    signupController.errors.gender
                      ? "error"
                      : ""
                  }
                  placeholder="Choose your gender"
                  options={GendersEnum}
                />
              </div>
              {/* address */}
              <div className="address">
                <label>Address</label>
                <TextArea
                  value={signupController.values.address}
                  onChange={signupController.handleChange}
                  name="address"
                  id="address"
                  disabled={loadings.signup}
                  status={
                    signupController.touched.address &&
                    signupController.errors.address
                      ? "error"
                      : ""
                  }
                  placeholder="Your address"
                />
              </div>
            </div>
            <TermsAcceptance
              checked={signupController.values.acceptedTerms}
              onChange={(accepted) =>
                signupController.setFieldValue("acceptedTerms", accepted)
              }
              onBlur={() => signupController.setFieldTouched("acceptedTerms", true)}
              disabled={loadings.signup}
              error={
                signupController.touched.acceptedTerms &&
                signupController.errors.acceptedTerms
              }
            />
            <Button
              loading={loadings.signup}
              className="signup_btn"
              htmlType="submit"
            >
              Sign Up
            </Button>
          </form>
        </div>
      ) : null}

      {step == 2 ? (
        <div className="reset_password_container">
          <div className="logo">
            <Logo1 />
          </div>
          {step == 2 || step == 3 ? (
            <div className="back_btn_mobile">
              <Button onClick={() => setStep(step === 2 ? 1 : 2)}>
                <IoIosArrowBack />
              </Button>
            </div>
          ) : null}
          {/* logo_mobile */}
          <div className="logo_mobile">
            <Logo />
          </div>
          <form
            onSubmit={verifySignupController.handleSubmit}
            className="confirmation_code"
          >
            <h3>Confirmation Code</h3>
            <p>
              We sent a reset link to{" "}
              {signupController.values?.email
                ? `${signupController.values?.email.slice(0, 4)}*****@${
                    signupController.values?.email?.split("@")[1]
                  }`
                : ""}{" "}
              enter 5 digit code that mentioned in the email
            </p>
            {/* otp_container */}
            <div className="otp_container">
              <OtpInput
                value={verifySignupController.values.token}
                onChange={(otp) => {
                  verifySignupController.setFieldValue("token", otp);
                }}
                shouldAutoFocus
                className="otpInput"
                numInputs={4}
                maxLength={4}
                inputMode="numeric"
                renderSeparator={<span style={{ width: "16px" }} />}
                renderInput={(props) => (
                  <input
                    {...props}
                    type="tel"
                    inputMode="tel"
                    autocomplete="tel"
                    pattern="[0-9]*"
                    disabled={loadings.verifySignup}
                    style={
                      verifySignupController.touched.token &&
                      verifySignupController.errors.token
                        ? {
                            width: "50px",
                            height: "50px",
                            fontSize: "18px",
                            borderRadius: "8px",
                            border: "1px solid red",
                            textAlign: "center",
                            outline: "none",
                            transition: "all .15s",
                          }
                        : {
                            width: "50px",
                            height: "50px",
                            fontSize: "18px",
                            borderRadius: "8px",
                            border: "1px solid var(--line)",
                            textAlign: "center",
                            outline: "none",
                            transition: "all .15s",
                          }
                    }
                  />
                )}
                focusStyle={{
                  border: "1px solid transparent",
                  boxShadow: "none",
                }}
              />
            </div>
            <Button
              htmlType="submit"
              className="confirmation_code_btn"
              loading={loadings.verifySignup}
            >
              <span>Verify Code</span>
            </Button>
          </form>
          <div className={"time_container"}>
            {showReset == true ? (
              <div className={"timer"}>
                <div className={"time_resend_code"}>
                  <span
                    className="font_medium"
                    style={
                      showReset
                        ? { color: "var(--second)" }
                        : { color: "var(--gary_50)" }
                    }
                  >
                    00 : 00
                  </span>
                </div>
              </div>
            ) : (
              <div className={"timer"}>
                <Countdown
                  date={now}
                  zeroPadTime={2}
                  precision={3}
                  renderer={renderer}
                  onComplete={() => {
                    setShowReset(true);
                    setNow(null);
                  }}
                />
              </div>
            )}
            <div
              style={{
                marginTop: "8px",
                fontSize: "14px",
                color: "var(--text)",
              }}
            >
              Haven't got the email yet?
              <span
                style={
                  loadings.resendVerificationCode
                    ? {
                        color: showReset ? "var(--blue)" : "var(--gary_50)",
                        textDecoration: "underline",
                        cursor: "not-allowed",
                        marginLeft: "5px",
                        filter: "blur(1.5px)",
                      }
                    : {
                        color: showReset ? "var(--blue)" : "var(--gary_50)",
                        textDecoration: "underline",
                        cursor: showReset ? "pointer" : "not-allowed",
                        marginLeft: "5px",
                      }
                }
                onClick={() => {
                  if (showReset == true) {
                    resendVerificationCode(signupController.values.email, 3);
                  }
                }}
              >
                Resend email
              </span>
            </div>
          </div>
        </div>
      ) : null}

      {step == 3 ? (
        <div className="signup_done_container">
          <div className="logo">
            <Logo1 />
          </div>
          {/* logo_mobile */}
          <div className="logo_mobile">
            <Logo />
          </div>
          {/* done */}
          <div className="done">
            <DoneIcon />
            <h3>Your request has been submitted to Naranal.</h3>
            <p>
              Once it is reviewed and approved by our team, your password will
              be sent to your email
            </p>
          </div>
          <Button
            className="ok_btn"
            onClick={() => {
              navigate("/login");
            }}
          >
            <span>Ok</span>
          </Button>
        </div>
      ) : null}
    </div>
  );
};
export default Signup;
